<template>
  <QsDrawer
    :title="configData.title"
    :visible.sync="isShow"
    @close="cancelHandle"
    cusSize="lg"
    :destory-on-close="true"
    :append-to-body="true"
    :destroy-on-close="true"
    :modal-append-to-body="false"
  >
    <div class="drawer-content">
      <el-steps
        v-if="!isAddScheme && !isLateFee && !isCustomFee"
        :active="active"
        finish-status="success"
        align-center
      >
        <el-step
          v-for="item of stepsList"
          @click.native="clickSteps(item.id)"
          :title="item.title"
          :key="item.id"
        />
      </el-steps>
      <CustomFeeItem
        v-if="isCustomFee"
        :configData="configData"
        ref="customFeeItemRef">

      </CustomFeeItem>
      <component
        v-if="!isCustomFee && isShow"
        ref="component"
        :rentCategory="Number(rentCategory)"
        :configData="configData"
        :tableDataFrom="tableDataFrom"
        :configDisabled="configDisabled"
        :tempFormData="tempFormData"
        :leaseSchemeMaxDate="leaseSchemeMaxDate"
        :isAddScheme="isAddScheme"
        :isPersonalSignContract="isPersonalSignContract"
        :isECommerce="isECommerce"
        :isRenew="isRenew"
        @closeDrawer="closeDrawer"
        :is="stepsList[active].components"
      />
    </div>
    <template #footer>
      <template v-if="isAddScheme || isLateFee || isCustomFee">
        <el-button @click="cancelHandle" size="small">取消</el-button>
        <el-button @click="calculatePaymentPlan" size="small" type="primary">确定</el-button>
      </template>
      <template v-else-if="active === 0">
        <el-button @click="cancelHandle" size="small">取消</el-button>
        <el-button
          :loading="btnLoading"
          @click="calculatePaymentPlan"
          size="small"
          type="primary"
          >下一步，确认账单</el-button
        >
      </template>
      <template v-else-if="active === 1">
        <el-button @click="cancelHandle" size="small">取消</el-button>
        <el-button @click="goStep(0)" size="small">上一步</el-button>
        <el-button @click="confirmHandle" size="small" type="primary">确定</el-button>
      </template>
    </template>
  </QsDrawer>
</template>
<script>
import { depositInstallmentCheck, getPreviewedPlan } from '@/api/domain/orders'
import { isNewOverdueForRentPlanConfig } from '@/pages/utils/overdue'
import {
  AMOUNTTYPE_CODE_MAP,
  FEE_CODE_MAP,
  PAYMODE_CODE_MAP,
} from '@/store/dict/rentPlanDict'
import { calculateMonths } from '@/utils/index.js'
import { cloneDeep } from 'lodash'
import { mapState } from 'vuex'
import AccountReceivable from './components/AccountReceivable.vue'
import SetPaymentPlan from './components/SetPaymentPlan.vue'
import CustomFeeItem from './components/CustomFeeItem.vue'
import { DYNAMIC_TYPE, formItemList, RENT_TYPE, SCENE_TYPE } from './config.js'

export default {
  model: {
    prop: 'show',
    event: 'change',
  },
  inject: {
    getPlanId: {
      default: () => () => null,
    },
  },
  components: {
    CustomFeeItem,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    configPaymentPlan: {
      type: Object,
      default: () => ({}),
    },
    configDisabled: {
      type: Boolean,
      default: false,
    },
    // 场景
    scene: {
      type: String,
      default: SCENE_TYPE.LEASE_PLAN,
    },
    step: {
      type: Number,
      default: 1,
    },
    rentCategory: {
      type: [String, Number],
      default: 1,
    },
    // 是否为商城单，商城单不允许修改
    isECommerce: {
      type: Boolean,
      default: false,
    },
    // 是否为续约单，true为是，false为否
    isRenew: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formItemList,
      tableDataFrom: {
        tableData: [],
      },
      stepsList: [
        {
          id: 0,
          title: '设置支付计划',
          components: SetPaymentPlan,
        },
        {
          id: 1,
          title: '确认对应账单',
          components: AccountReceivable,
        },
      ],
      active: 0,
      isShow: false,
      btnLoading: false,
      leaseSchemeMaxDate: 0,
      configData: {},
      tempFormData: {},
      formData: {
        startTime: '',
        endTime: '',
        payMode: '',
        rentPerPeriod: '',
        rentDay: '',
        amount: '',
        amountType: AMOUNTTYPE_CODE_MAP.AMOUNT_PER_PERIOD, // 1 每期 2 日租金
        amountAccuracy: 2, // 保留小数 0 取整 2 保留两位小数
        lateFeeProportion: '',
        interestFreeDays: '',
        payPlanType: RENT_TYPE.FIXEDRENT,
        advancePayment: '', // 提车时需缴纳
      },
    }
  },
  created() {
    this.$store.dispatch('getPaymentMethods', { type: 'rentOrderFeeType' }) // 获取收款项
  },
  watch: {
    show(val) {
      this.isShow = val
      if (val) {
        this.active = this.step - 1
        this.init()
        this.$nextTick(() => {
          this.$refs.component?.init && this.$refs.component.init()
        })
      }
    },
    isShow(val) {
      this.$emit('change', val)
    },
  },
  computed: {
    isAddScheme() {
      return this.scene === SCENE_TYPE.LEASE_PLAN
    },
    // 是否是滞纳金
    isLateFee() {
      const { formData } = this.configPaymentPlan
      return isNewOverdueForRentPlanConfig(formData)
    },
    // 租赁方案ID
    planId() {
      return this.getPlanId()
    },
    // 是否为后置费项
    isCustomFee() {
      return this.configPaymentPlan.customFlag === 1
    },
    isPersonalSignContract() {
      return this.scene === SCENE_TYPE.SIGN_CONTRACT
    },
  },
  methods: {
    closeDrawer() {
      this.isShow = false
    },
    clickSteps(id) {
      if (id === 0 && id !== this.active) {
        this.goStep(id)
      }
    },
    init() {
      this.formData = {
        startTime: '',
        endTime: '',
        payMode: '',
        rentPerPeriod: '',
        rentDay: '',
        amount: '',
        customerDueDate: '',
        amountType: '', // 1 每期 2 日租金
        amountAccuracy: '', // 不足月保留单位 -2元/-1角/0分
        lateFeeProportion: '',
        interestFreeDays: '',
        payPlanType: RENT_TYPE.FIXEDRENT,
        dynamicType: DYNAMIC_TYPE.OVER_ORDER_NUM,
        spId: '', // 完单平台
        dynamicList: [
          {
            startValue: 0, // 最小完单量
            endValue: '', // 最大完单量
            amount: '', // 租金
            maxDisabled: false,
          },
          {
            startValue: null, // 最小完单量
            endValue: null, // 最大完单量
            amount: '', // 租金
            maxDisabled: false,
          },
        ],
        advancePayment: '',
      }

      if (!this.configDisabled) {
        this.formData.amountType = AMOUNTTYPE_CODE_MAP.AMOUNT_PER_PERIOD
        this.formData.amountAccuracy = 2
      }

      const { formData = {} } = this.configPaymentPlan
      const { fundType, items = [] } = formData

      this.tableDataFrom.tableData = cloneDeep(items)

      if (!this.isLateFee) {
        this.tableDataFrom.tableData.forEach((item, index) => {
          item.num = index + 1
          item.accruedCycle = [item.startCycleDate, item.endCycleDate]
        })

        // 去掉为null的字段
        Object.keys(formData).forEach((item) => {
          if (formData[item] === null) delete formData[item]
        })
      }

      // 可配置区间数
      if (this.isAddScheme) {
        if (formData.rentPeriodType === 3) {
          this.leaseSchemeMaxDate = Number(formData.rentPeriod)
        } else {
          this.leaseSchemeMaxDate = Math.ceil(Number(formData.rentPeriod) / 30)
        }
      } else {
        this.leaseSchemeMaxDate = calculateMonths(
          formData.endTime,
          formData.startTime,
        )
      }
      // 首付款、全款、定金、保证金
      if (
        [
          FEE_CODE_MAP.YA_JIN,
          FEE_CODE_MAP.SHOU_FU_KUAN,
          FEE_CODE_MAP.QUAN_KUAN,
          FEE_CODE_MAP.DING_JIN,
          FEE_CODE_MAP.BAO_ZHENG_JIN,
        ].includes(fundType)
      ) {
        if (!this.configDisabled) {
          this.formData.payMode = PAYMODE_CODE_MAP.DISPOSABLE
        }
      }
      // 尾款、滞纳金
      if (
        fundType === FEE_CODE_MAP.ZHI_NA_JIN ||
        fundType === FEE_CODE_MAP.WEI_KUAN
      ) {
        if (!this.configDisabled) {
          this.formData.payMode = PAYMODE_CODE_MAP.DISPOSABLE
        }
      }
      // 管理费、服务费、租金，收款方式与外面保持一致
      if (
        fundType === FEE_CODE_MAP.GUAN_LI_FEE ||
        fundType === FEE_CODE_MAP.FU_WU_FEE ||
        fundType === FEE_CODE_MAP.ZU_JIN
      ) {
        if (!this.configDisabled) {
          this.formData.payMode = this.configPaymentPlan.formData.payMode
        }
      }
      // 弹窗标题
      const titleName = this.configPaymentPlan.feeName

      // 获取配置
      const item = this.formItemList.find((Item) => {
        return Item.code === fundType
      })
      const { showFormItem = {} } = item || {}
      this.formData = Object.assign(this.formData, formData)

      if (this.formData.payMode === PAYMODE_CODE_MAP.DISPOSABLE) {
        this.formData.customerDueDate = formData.dueDate || formData.startTime
      }

      const {
        payMode,
        amountAccuracy,
        customerDueDate,
        amountType,
        amount,
        isPayPostCustom,
      } = this.formData

      // 回显金额
      if (amountType === AMOUNTTYPE_CODE_MAP.AMOUNT_PER_PERIOD) {
        this.formData.rentPerPeriod = amount
      }
      if (amountType === AMOUNTTYPE_CODE_MAP.DAILY_RENT) {
        this.formData.rentDay = amount
      }

      // 提车时需缴纳赋值
      this.formData.advancePayment = this.configPaymentPlan.formData.advancePayment
      // 兼容历史方案
      this.tempFormData = {
        payMode: payMode !== '',
        amountType: amountType !== '',
        rentPerPeriod: this.formData.rentPerPeriod !== '',
        rentDay: this.formData.rentDay !== '',
        amount: amount !== '',
        customerDueDate: customerDueDate !== '' && !isPayPostCustom,
        amountAccuracy: amountAccuracy !== '',
      }

      if (!this.tempFormData.amountAccuracy) {
        this.formData.amountAccuracy = 0
      }

      if (!this.tempFormData.payMode) {
        if (
          fundType !== FEE_CODE_MAP.ZU_JIN &&
          fundType !== FEE_CODE_MAP.OTHERS
        ) {
          this.formData.payMode = PAYMODE_CODE_MAP.DISPOSABLE
        }
      }
      this.configData = {
        title: `配置${titleName}账单`,
        showFormItem,
        fundType,
        formData: this.formData,
      }
    },
    cancelHandle() {
      this.$emit('change', false)
    },
    goStep(step) {
      this.active = step
      this.$nextTick(() => {
        const { fundType, payMode } = this.formData

        if (
          fundType === FEE_CODE_MAP.YA_JIN &&
          payMode === PAYMODE_CODE_MAP.STAGES
        ) {
          this.$refs.component?.init &&
            this.$refs.component.init(this.tableDataFrom.tableData)
          return
        }
        this.$refs.component?.init && this.$refs.component.init()
      })
    },
    // 确定
    async confirmHandle() {
      const { customerDueDate, fundType, payMode } = this.formData

      if (
        fundType === FEE_CODE_MAP.YA_JIN &&
        payMode === PAYMODE_CODE_MAP.DISPOSABLE
      ) {
        this.formData.depositInstallmentList = []
      }

      if (
        fundType === FEE_CODE_MAP.YA_JIN &&
        payMode === PAYMODE_CODE_MAP.STAGES &&
        this.$refs?.component?.returnDepositInstallmentList
      ) {
        const depositInstallmentListCopy =
          await this.$refs?.component?.returnDepositInstallmentList()
        // 检查返回值是否为数组
        if (
          !depositInstallmentListCopy ||
          !Array.isArray(depositInstallmentListCopy) ||
          depositInstallmentListCopy.length === 0
        ) {
          return
        }
        const [err, res] = await this.$to(
          depositInstallmentCheck({
            type: 2,
            payMethod: 11,
            amount: depositInstallmentListCopy.reduce((sum, item) => {
              return sum + Number(item.presentAmount)
            }, 0),
            depositInstallmentList: [...depositInstallmentListCopy],
          }),
        )
        if (err || res?.code !== 1 || !res?.data) {
          return
        }
        this.formData.amount = depositInstallmentListCopy.reduce((sum, item) => {
          return sum + Number(item.presentAmount)
        }, 0)
        this.formData.depositInstallmentList = depositInstallmentListCopy
      }

      let arr = this.isLateFee ? [] : [...this.tableDataFrom.tableData]
      // 是否固定日期
      if (customerDueDate) {
        this.formData.payDate = customerDueDate
        this.formData.dueDate = customerDueDate
      }
      // 过滤不需要的字段
      arr = arr.map((item) => {
        const { dueDate, planAmount, accruedCycle, remarks } = item
        return {
          dueDate,
          endCycleDate: accruedCycle[1],
          planAmount,
          remarks,
          startCycleDate: accruedCycle[0],
        }
      })

      let res = false
      this.$refs.component?.$refs?.otherPayFrom &&
        this.$refs.component.$refs.otherPayFrom.validate((valid) => {
          res = valid
          if (!valid) {
            this.$nextTick(() => {
              const firstErrorEl = document.querySelector(
                '.add-table .el-form-item.is-error',
              )
              if (firstErrorEl) {
                firstErrorEl.scrollIntoView({
                  behavior: 'smooth',
                  block: 'center',
                })
              }
            })
          }
        })

      if (res || this.isAddScheme || this.isLateFee) {
        if (
          this.formData.payMode === PAYMODE_CODE_MAP.STAGES &&
          this.formData.fundType === FEE_CODE_MAP.YA_JIN && arr.length
        ) {
          this.formData.amount = arr.reduce((sum, item) => {
            return sum + Number(item.planAmount)
          }, 0)
        }
        this.$emit('getParams', {
          formData: this.formData,
          items: arr,
        })
        this.cancelHandle()
      }
    },
    // 处理金额
    handleArrears() {
      const { amountType, rentPerPeriod, rentDay, fundType, payMode } =
        this.formData
      if (
        fundType !== FEE_CODE_MAP.ZU_JIN ||
        (payMode !== PAYMODE_CODE_MAP.FULL_MOON &&
          payMode !== PAYMODE_CODE_MAP.NATURAL_MONTH &&
          payMode !== PAYMODE_CODE_MAP.WEEK)
      ) {
        return
      }
      if (amountType === AMOUNTTYPE_CODE_MAP.AMOUNT_PER_PERIOD) {
        this.formData.amount = rentPerPeriod
      }
      if (amountType === AMOUNTTYPE_CODE_MAP.DAILY_RENT) {
        this.formData.amount = rentDay
      }
    },
    // 计算支付计划
    async calculatePaymentPlan() {
      if (this.isCustomFee) {
        this.setCustomFormData()
        return
      }
      const { payPlanType, dynamicList } = this.formData // 租金类型
      if (payPlanType === RENT_TYPE.FIXEDRENT) this.handleArrears()

      let rules = false

      this.$refs.component.$refs.form.validate((valid) => {
        rules = valid
      })
      if (!rules) return
      const validateDayRent = this.$refs?.component?.validateDayRent ?? (() => false)
      if (!validateDayRent()) {
        return
      }
      const {
        fundType,
        startTime,
        endTime,
        amountType,
        payMode,
        amountAccuracy, // 保留小数 0 取整 2 保留两位小数
        amount,
        customerDueDate,
        spId,
        dynamicType,
      } = this.formData

      // 公共部分
      const commonParams = {
        rentPlanFeeType: fundType,
        bizType: 10, // 个人类型需要单独加枚举
        planId: this.planId,
        startTime,
        endTime,
        payMode,
        customerDueDate,
      }

      const payPlanParams = {
        // 固定租金
        [RENT_TYPE.FIXEDRENT]: {
          amountType: Number(amountType), // 每期租金 每日租金
          amount, // 租金 固定租金的时候才会有
        },
        // 动态租金
        [RENT_TYPE.DYNAMICRENT]: {
          payPlanType, // 租金类型
          spId, // 完单平台
          dynamicType, // 动态条件
          dynamicList, // 租金规则
        },
      }
      const params = {
        ...commonParams,
        ...payPlanParams[payPlanType],
        rentCategory: this.rentCategory,
      }

      if (
        fundType === FEE_CODE_MAP.YA_JIN &&
        payMode === PAYMODE_CODE_MAP.DISPOSABLE
      ) {
        params.depositInstallmentList = []
      }

      if (
        fundType === FEE_CODE_MAP.YA_JIN &&
        payMode === PAYMODE_CODE_MAP.STAGES &&
        this.$refs?.component?.returnDepositInstallmentList &&
        this.isAddScheme
      ) {
        const depositInstallmentListCopy =
          await this.$refs.component?.returnDepositInstallmentList()
        // 检查返回值是否为数组
        if (
          !depositInstallmentListCopy ||
          !Array.isArray(depositInstallmentListCopy)
        ) {
          return
        }
        const [err, res] = await this.$to(
          depositInstallmentCheck({
            type: 2,
            payMethod: 11,
            amount: depositInstallmentListCopy.reduce((sum, item) => {
              return sum + Number(item.presentAmount)
            }, 0),
            depositInstallmentList: [...depositInstallmentListCopy],
          }),
        )
        if (err || res?.code !== 1 || !res?.data) {
          return
        }
        params.depositInstallmentList = [...depositInstallmentListCopy]
      }

      /**
       * fundType费项类型为租金/其他 并且 payMode付款类型为周付、自然月付、满月付的时加上保留几位小数字段
       */
      if (
        (fundType === FEE_CODE_MAP.ZU_JIN ||
          fundType === FEE_CODE_MAP.OTHERS) &&
        (payMode === PAYMODE_CODE_MAP.WEEK ||
          payMode === PAYMODE_CODE_MAP.FULL_MOON ||
          payMode === PAYMODE_CODE_MAP.NATURAL_MONTH)
      ) {
        params.amountAccuracy = amountAccuracy
      }

      /*
        fundType类型不等于滞纳金
        且amount为空
        且payPlanType为固定租金的时候
      */
      if (
        fundType !== FEE_CODE_MAP.ZHI_NA_JIN &&
        fundType !== FEE_CODE_MAP.YA_JIN &&
        (amount === '' || amount === undefined) &&
        payPlanType === RENT_TYPE.FIXEDRENT
      ) {
        this.$refs.component.amountChange()
        return this.$message.warning('请确认收款金额及配置已正确填写')
      }

      // 新增租赁方案
      if (this.isAddScheme || this.isLateFee) {
        return this.confirmHandle()
      }

      // 如果是押金分期 就直接放过 去下一步配置 自定义的时候 添加默认一行的tabledata
      if (
        fundType === FEE_CODE_MAP.YA_JIN &&
        payMode === PAYMODE_CODE_MAP.STAGES
      ) {
        if (!this.planId) {
          this.tableDataFrom.tableData = [
            {
              num: 1,
              accruedCycle: [startTime, endTime],
              planAmount: '',
            },
          ]
        }
        this.goStep(1)
        return
      }
      this.btnLoading = true
      // 需要告诉服务端是否为续约单，1表示为续约单，0表示非续约单
      // 服务端用来做逻辑处理：非续约单租金不能为0，续约单不用管
      params.renewal = this.isRenew ? 1 : 0
      getPreviewedPlan(params)
        .then((res) => {
          const { code, data } = res
          if (code === 1) {
            const { accruedPlanList = [], totalAmount = 0 } = data || {}
            this.tableDataFrom.tableData = accruedPlanList
            this.configData.formData.receivableTotalAmount = totalAmount
            this.configData.formData.totalAmount = totalAmount
            this.configData.formData.amount = amount
            this.tableDataFrom.tableData.forEach((item, index) => {
              item.num = index + 1
              this.$set(item, 'accruedCycle', [
                item.startCycleDate,
                item.endCycleDate,
              ])
            })
            this.goStep(1)
          }
        })
        .finally(() => {
          this.btnLoading = false
        })
    },
    // 后置费项设置值
    async setCustomFormData() {
      const formData = await this.$refs.customFeeItemRef.getFormData()
      if (!formData) {
        return false
      }
      this.$emit('getParams', {
        formData,
        customFlag: 1,
        name: this.configPaymentPlan.feeName,
        fundTypeName: this.configPaymentPlan.feeName,
      })
      this.isShow = false
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-dialog__body {
    scrollbar-gutter: stable;
    scrollbar-width: thin;
  }
}
.drawer-content {
  width: 100%;
  min-height: 100%;
  padding: 0px 16px;
}
::v-deep {
  .drawer-footer {
    margin-left: 0;
    width: auto;
  }
  .el-drawer__header {
    margin-bottom: 12px;
  }
}
</style>
